<script>
export default {
  name: "ArticleContentMeaning",
  props: {
    meaning: {
      type: Object,
      required: true
    },
    hideComment: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasComment() {
      return this.meaning.comment && !this.hideComment;
    }
  }
};
</script>

<template>
  <div>
    <div
      v-if="meaning.phrase"
      class="article-content__politiken-grid-indexed article-content__politiken-grid-indexed--simple"
    >
      <div
        v-if="meaning.polysem"
        class="article-content__text article-content__text--dark article-content__text--prominent article-content__politiken-grid-indexed-index"
      >
        {{ meaning.polysem }}
      </div>
      <div class="article-content__politiken-grid-indexed-content">
        <span
          class="article-content__text article-content__text--dark article-content__text--italic pr-2"
          v-html="meaning.phrase"
        />
      </div>
    </div>
    <div
      v-if="hasComment"
      class="article-content__politiken-grid-indexed article-content__politiken-grid-indexed--simple"
    >
      <div
        v-if="meaning.polysem"
        class="article-content__text article-content__text--dark article-content__text--prominent article-content__politiken-grid-indexed-index"
      >
        {{ meaning.polysem }}
      </div>
      <div class="article-content__politiken-grid-indexed-content">
        <span
          class="article-content__text article-content__text--dark article-content__text--italic pr-2"
          >({{ meaning.comment }})</span
        >
      </div>
    </div>
    <div v-if="meaning.definition" class="article-content__politiken-grid-indexed">
      <div
        v-if="!meaning.phrase && !hasComment && meaning.polysem"
        class="article-content__text article-content__text--dark article-content__text--prominent article-content__politiken-grid-indexed-index"
      >
        {{ meaning.polysem }}
      </div>
      <div class="article-content__text article-content__politiken-grid-indexed-label">
        {{ $t("article.polChildrensDada.meaning") }}
      </div>
      <div class="article-content__politiken-grid-indexed-content">
        <span class="article-content__text article-content__text--primary pr-2">{{
          meaning.definition
        }}</span>
      </div>
    </div>
    <div v-if="meaning.example" class="article-content__politiken-grid-indexed">
      <div
        v-if="!meaning.phrase && !meaning.definition && !hasComment && meaning.polysem"
        class="article-content__text article-content__text--dark article-content__text--prominent article-content__politiken-grid-indexed-index"
      >
        {{ meaning.polysem }}
      </div>
      <div class="article-content__text article-content__politiken-grid-indexed-label">
        {{ $t("article.polChildrensDada.example") }}
      </div>
      <div class="article-content__politiken-grid-indexed-content">
        <span
          class="article-content__text article-content__text--light article-content__text--italic pr-2"
          v-html="meaning.example"
        />
      </div>
    </div>
  </div>
</template>
